module.exports = __webpack_public_path__ + "media/images/icons/question_key_mobile-fab720237c4603b859b0b32c398a95e7.svg";